import Logout from './Logout.component';

export default Logout;
